import React from "react";
import stilePulsanti from "../interfaccia/stilePulsanti";

function Tema({nomeTema, labelTema, temaColoriAttuale, setTemaColori}) {

    /* const imposta = function(e) {
        setTemaColori(nomeTema);
    } */
    
    const {
        tastoQuadratoBianco
    } = stilePulsanti
    
    return(
        <div className="flex tema mb4">
            
            {temaColoriAttuale !== nomeTema && <p className="fw3 w-20">{labelTema}</p>}
            {temaColoriAttuale === nomeTema && <p className="fw5 w-20">{labelTema}</p>}
            <div className={nomeTema+" flex tc"}>
                <div className={"quadratinoNonCliccabile sfondoBiancoTema"}> A </div>
                <div className={"quadratinoNonCliccabile sfondoColScuro"}> A </div>
                <div className={"quadratinoNonCliccabile sfondoColMedio"}> A </div>
                <div className={"quadratinoNonCliccabile sfondoColChiaro"}> A </div>  
                <div className={"quadratinoNonCliccabile sfondoColAlt"}> A </div>
                <div className={"quadratinoNonCliccabile sfondoColAltScuro"}> A </div>              
            </div>
            {temaColoriAttuale !== nomeTema && <button 
            className={tastoQuadratoBianco+" ml3 "} 
            onClick={()=>setTemaColori(nomeTema)}>Imposta tema</button>}
            {temaColoriAttuale ===  nomeTema && <p className="tc ml3 ">Tema selezionato</p>}
        </div>
    )
}

export default Tema;